<template>
  <div class="row">
    <div class="col-12 custom-json-wrapper">
      <div class="row custom-result-list">
        <div v-if="groups.length === 0" class="col-12">
          <span>Sorry, the data you requested is not yet available from ALLDATA.</span>
        </div>
        <div v-else class="col-12">
          <div v-for="(group, idx) in groups" :key="idx">
            <button :id="`accordion-${idx}`" class="accordion btn btn-link btn-block" @click="toggleAccordion(idx)">
              <div class="custom-group">
                {{ group.group }}
              </div>
            </button>
            <div :id="`panel-${idx}`" class="accordion-panel">
              <ul class="custom-list">
                <li v-for="(link, idx2) in group.links" :key="idx2" class="custom-list-item">
                  <div v-html="link.title"></div>
                  <a :href="link.url" target="_blank">{{ link.article }}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AlldataLinks',
  props: {
    linkInfo: {
      type: Object,
      default: null
    },
    links: Object
  },
  data() {
    return {
      alldataUrlMap: '',
      alldataUrlFilterMap: ''
    }
  },
  mounted() {
    this.alldataUrlMap = window.config ? window.config.alldataUrlMap : ''
    this.alldataUrlFilterMap = window.config ? window.config.alldataUrlFilterMap : ''
  },
  computed: {
    source() {
      let _data = null
      if (this.linkInfo) {
        _data = this.linkInfo.source
      }
      return _data
    },
    adasChecklistMatrix() {
      let _data = null
      if (this.linkInfo) {
        _data = this.linkInfo.adasChecklistMatrix
      }
      console.log('Link Info', this.linkInfo)
      return _data
    },
    groups() {
      let _data = []
      let proceed = true
      if (this.links !== undefined && this.links !== null) {
        if (Array.isArray(this.links)) {
          if (this.source === 'General') {
            let generalLinks = []
            // General Information Links
            let filtered = this.links.filter((x) => x.lookupType === 2)
            if (filtered) {
              filtered.forEach((link) => {
                generalLinks.push({
                  article: link.keywords,
                  url: link.url,
                  category: link.lookupType
                })
              })
              _data.push({
                group: 'General',
                links: generalLinks
              })
            }
          } else {
            // ALLDATA Links
            this.links.forEach((element) => {
              if (element.links !== null) {
                proceed = true
                if (element.links._embedded === undefined || element.links._embedded === null) {
                  proceed = false
                }
                if (proceed && (element.links._embedded.data === undefined || element.links._embedded.data === null)) {
                  proceed = false
                }
                if (proceed && (element.links._embedded.data.GEN3NA === undefined || element.links._embedded.data.GEN3NA === null)) {
                  proceed = false
                }
                if (
                  proceed &&
                  (element.links._embedded.data.GEN3NA._embedded === undefined || element.links._embedded.data.GEN3NA._embedded === null)
                ) {
                  proceed = false
                }
                if (
                  proceed &&
                  (element.links._embedded.data.GEN3NA._embedded.data === undefined || element.links._embedded.data.GEN3NA._embedded.data === null)
                ) {
                  proceed = false
                }
                if (
                  proceed &&
                  (element.links._embedded.data.GEN3NA._embedded.data.results === undefined ||
                    element.links._embedded.data.GEN3NA._embedded.data.results === null)
                ) {
                  proceed = false
                }
                if (proceed) {
                  element.links._embedded.data.GEN3NA._embedded.data.results.forEach((link) => {
                    let links = []
                    link.results.forEach((grouplink) => {
                      let contents = grouplink.display.split('>>')
                      let title = ''
                      for (let idx = 0; idx < contents.length - 1; idx++) {
                        if (idx < contents.length - 2) {
                          title = title + contents[idx] + '<i class="fas fa-angle-double-right"></i>'
                        } else {
                          title = title + contents[idx]
                        }
                      }
                      links.push({
                        title: title,
                        article: contents[contents.length - 1],
                        name: grouplink.display,
                        url: grouplink.isOpus === undefined ? this.processLink(grouplink._links.self.href) : grouplink._links.self.href,
                        category: link.groupCategory.id
                      })
                    })
                    _data.push({
                      group: link.groupCategory.name,
                      links: links
                    })
                  })
                }
              }
            })
          }
        } else {
          proceed = true
          if (this.links !== '') {
            if (this.links === undefined || this.links === null) {
              proceed = false
            }
            if (proceed && (this.links._embedded === undefined || this.links._embedded === null)) {
              proceed = false
            }
            if (proceed && (this.links._embedded.data === undefined || this.links._embedded.data === null)) {
              proceed = false
            }
            if (proceed && (this.links._embedded.data.GEN3NA === undefined || this.links._embedded.data.GEN3NA === null)) {
              proceed = false
            }
            if (proceed && (this.links._embedded.data.GEN3NA._embedded === undefined || this.links._embedded.data.GEN3NA._embedded === null)) {
              proceed = false
            }
            if (
              proceed &&
              (this.links._embedded.data.GEN3NA._embedded.data === undefined || this.links._embedded.data.GEN3NA._embedded.data === null)
            ) {
              proceed = false
            }
            if (
              proceed &&
              (this.links._embedded.data.GEN3NA._embedded.data.results === undefined ||
                this.links._embedded.data.GEN3NA._embedded.data.results === null)
            ) {
              proceed = false
            }
            if (proceed) {
              this.links._embedded.data.GEN3NA._embedded.data.results.forEach((link) => {
                let links = []
                link.results.forEach((grouplink) => {
                  let contents = grouplink.display.split('>>')
                  let title = ''
                  for (let idx = 0; idx < contents.length - 1; idx++) {
                    if (idx < contents.length - 2) {
                      title = title + contents[idx] + '<i class="fas fa-angle-double-right"></i>'
                    } else {
                      title = title + contents[idx]
                    }
                  }
                  links.push({
                    title: title,
                    article: contents[contents.length - 1],
                    name: grouplink.display,
                    url: grouplink.isOpus === undefined ? this.processLink(grouplink._links.self.href) : grouplink._links.self.href,
                    category: link.groupCategory.id
                  })
                })
                _data.push({
                  group: link.groupCategory.name,
                  links: links
                })
              })
            }
          }
        }
      }
      return _data
    }
  },
  methods: {
    toggleAccordion(idx) {
      let acc = document.getElementById(`accordion-${idx}`)
      acc.classList.toggle('accordion-active')
      let accPanel = document.getElementById(`panel-${idx}`)
      if (accPanel.style.maxHeight) {
        accPanel.style.maxHeight = null
      } else {
        accPanel.style.maxHeight = accPanel.scrollHeight + 'px'
      }
    },
    processLink(link) {
      let data = {
        carid: '',
        component: '',
        itype: '',
        article: ''
      }
      // https://my-beta.alldata.com/ADAG/repair/ADConnect/v5/carids/59539/components/1242/itypes/35/nonstandards/11755?locale=en_US
      // https://my-beta.alldata.com/repair/#/repair/article/{{carid}}/component/{{component}}/itype/{{itype}}/nonstandard/{{article}}/selfRefLink/false
      // if itype and standards are missing, use:
      // https://my-beta.alldata.com/repair/#/repair/vehicle/61306/component/3715/filter/
      // url.protocol; //(http:)
      // url.hostname; //(www.example.com)
      // url.pathname; //(/some/path)
      // url.search; // (?name=value)
      // url.hash; //(#anchor)
      var url = new URL(link)
      var pathItems = url.pathname.split('/')
      let last = ''
      pathItems.forEach((element) => {
        if (last === 'carids') {
          data.carid = element
        } else if (last === 'components') {
          data.component = element
        } else if (last === 'itypes') {
          data.itype = element
        } else if (last === 'nonstandards') {
          data.article = element
        }
        last = element
      })
      let newUrl = this.alldataUrlMap
      if (data.itype === '' || data.article === '') {
        newUrl = this.alldataUrlFilterMap
      }
      newUrl = newUrl.replace('{{carid}}', data.carid)
      newUrl = newUrl.replace('{{component}}', data.component)
      if (data.itype !== '' && data.article !== '') {
        newUrl = newUrl.replace('{{itype}}', data.itype)
        newUrl = newUrl.replace('{{article}}', data.article)
      }
      return newUrl
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-json-wrapper {
  max-height: 600px;
  overflow: auto;
}
.custom-result-list {
  width: 100%;
  height: 500px;
  max-height: 500px;
  overflow-x: hidden;
  overflow-y: scroll;
  padding-top: 5px;
}
.custom-group {
  font-size: 1.1em;
  font-weight: 500;
}
.custom-list {
  list-style-type: none;
  li {
    padding: 5px;
  }
  li:hover {
    background-color: rgb(219, 219, 219);
    cursor: pointer;
  }
  a {
    text-decoration: none;
    margin-top: 5px;
    margin-bottom: 5px;
  }
}
.custom-list-item {
  div {
    width: 100%;
    font-size: 0.8em;
    font-weight: 500;
    margin-bottom: 8px;
  }
}
</style>
